import {
  Button,
  Modal,
  ModalBody,
  SquareNewWindowIcon,
  Tab,
  TabPanel,
  Tabs,
} from "@codat/orchard-ui";
import { useState } from "react";

import { sendAmplitudeEvent } from "../../amplitude";
import config from "../../config";
import { CompanySummary } from "../../Models";
import styles from "./CompanyDetailsModal.module.css";
import ConnectorTab from "./ConnectorTab/ConnectorTab";
import SystemTab from "./SystemTab/SystemTab";

interface CompanyDetailsModalProps {
  handleClose: () => void;
  isOpen: boolean;
  company: CompanySummary | null;
  isLatest: (integration: string, version: string) => boolean;
}
const CompanyDetailsModal: React.FC<CompanyDetailsModalProps> = ({
  handleClose,
  isOpen,
  company,
  isLatest,
}) => {
  const [selectedTabId, setSelectedTabId] = useState("Connector");

  const handleTabChange = (
    e: React.MouseEvent<HTMLButtonElement>,
    value: string
  ) => {
    e.preventDefault();
    setSelectedTabId(value);
    if (value === "System") {
      sendAmplitudeEvent({
        element: "System tab",
        action: "Click",
      });
    }
  };

  return (
    <Modal className={styles.modal} onClose={handleClose}>
      {isOpen && company && (
        <ModalBody
          className={styles.modalBody}
          size="large"
          title={company.companyName}
          onClose={handleClose}
        >
          <Tabs
            selectedTabId={selectedTabId}
            onTabChange={handleTabChange}
            className={styles.tabs}
            label="company-tabs"
          >
            <Tab label="Connector" id="Connector" />
            <Tab label="System" id="System" />
            <a
              href={`${config.PORTAL_URL}/companies/${company.companyId}/pull-history/`}
              onClick={() =>
                sendAmplitudeEvent({
                  element: "View Syncs Button",
                  action: "Click",
                })
              }
              target="_blank"
              style={{ marginLeft: "auto" }}
              rel="noreferrer"
            >
              <Button size="small">
                View Syncs
                <SquareNewWindowIcon className={styles.newWindow} />
              </Button>
            </a>
          </Tabs>

          <TabPanel tabId="Connector" selectedTabId={selectedTabId}>
            <ConnectorTab company={company} isLatest={isLatest} />
          </TabPanel>
          <TabPanel tabId="System" selectedTabId={selectedTabId}>
            <SystemTab company={company} />
          </TabPanel>
        </ModalBody>
      )}
    </Modal>
  );
};

export default CompanyDetailsModal;
